/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _style6 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style7 = require('antd/lib/col/style');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _style8 = require('antd/lib/row/style');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _style9 = require('antd/lib/modal/style');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style10 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var _ref = (0, _jsx3.default)(_col2.default, {
  span: 7,
  className: 'ele-0'
}, void 0, (0, _jsx3.default)('strong', {}, void 0, '\u8BBE\u5907\u7F16\u53F7\uFF1A'));

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    // this.state = 0;
    // this.state= {
    //   page: 0,
    // };
    // this.state = { editDeviceInfo: {}  }
    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.submitOk = function () {
      var _this$props = _this.props,
          form = _this$props.form,
          editDeviceInfo = _this$props.editDeviceInfo,
          onCreate = _this$props.onCreate;

      form.validateFields(function (err, values) {
        if (!err) {
          var o = {
            id: editDeviceInfo.deviceId,
            name: values['device-name']
          };
          onCreate(o);
          form.resetFields();
        }
      });
    };

    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // let { fetchPosts } = this.props;
    }
  }, {
    key: 'render',
    value: function render() {
      // let {demoData} = this.props;
      if (__DEV__) {
        // if( !fetchData.isFetching ){
        //   console.log( this.props );
        // }
      }
      var _props = this.props,
          visible = _props.visible,
          onCancel = _props.onCancel,
          onCreate = _props.onCreate,
          form = _props.form,
          editDeviceInfo = _props.editDeviceInfo;
      var getFieldDecorator = form.getFieldDecorator,
          getFieldValue = form.getFieldValue;

      var formItemLayout = {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      };
      //console.log(editDeviceInfo);
      return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_modal2.default, {
        title: '\u7F16\u8F91\u8BBE\u5907\u4FE1\u606F',
        className: 'cus-modal',
        visible: visible,
        onCancel: onCancel,
        onOk: this.submitOk,
        okText: '\u786E\u8BA4',
        cancelText: '\u53D6\u6D88'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'device-info-modal'
      }, void 0, (0, _jsx3.default)(_row2.default, {
        className: 'no-edit'
      }, void 0, _ref, (0, _jsx3.default)(_col2.default, {
        span: 17,
        className: 'ele-1'
      }, void 0, (0, _jsx3.default)('span', {}, void 0, editDeviceInfo.deviceId))), (0, _jsx3.default)(_form2.default, {
        className: 'able-edit'
      }, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemLayout, {
          label: '\u8BBE\u5907\u540D\u79F0',
          required: false,
          key: 0
        }),
        getFieldDecorator('device-name', {
          validateTrigger: ['onChange', 'onBlur'],
          initialValue: editDeviceInfo.deviceName,
          rules: [{
            required: true,
            whitespace: true,
            message: "请输入设备名称"
          }]
        })((0, _jsx3.default)(_input2.default, {
          placeholder: '\u8BBE\u5907\u540D\u79F0',
          style: { 'width': '60%' }
        }))
      )))));
    }
  }]);
  return Main;
}(_react.Component);

var Edit = _form2.default.create()(Main);

exports.default = (0, _reactRouter.withRouter)(Edit);

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/list/edit/index.jsx
// module id = 936
// module chunks = 0